import api from '@/apis/di/employeeTypeAPI.js';
import Crud from '@/stores/crudBase';
var crud = new Crud('employeeType', api);

const state = {
  ...crud.state,
  _config: {
    table: 'di_employee_type',
    field: {
      key: 'employee_type_id',
      code: 'employee_type_code',
      name: 'employee_type_name',
      quickFollow: 'inactive',
    },
  },
};
const getters = {
  ...crud.getters,
};
const actions = {
  ...crud.actions,
};
const mutations = {
  ...crud.mutations,
};

export default {
  debug: process.env.NODE_ENV !== 'production',
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
